import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Link, withRouter} from 'react-router-dom';
import {instance, mesAutobind} from '@posco/posco-shared';
import {dialog, Input, message, SpinnerViewer} from '@posco/posco-ui-react';

import LoginLogoImg from '../style/login_logo.png';
import Footer from './Footer';

import '@posco/posco-ui-react/dist/lib/mes-desktop.css';
import PortalRepository from "../api/PortalRepository";


@withRouter
@mesAutobind
class Login extends Component {

  @instance(PortalRepository.instance)
  static instance;

  static propTypes = {
    mainPath: PropTypes.string,
    withCompany: PropTypes.bool,
  };

  static defaultProps = {
    withCompany: false,
  };

  state = {
    loginId: '',
    loginPassword: '',
  };

  nameInput = null;
  repository;

  // Line No. 37 : Failure Definition Function. => function -> const
  componentDidMount = () => {
    //localStorage 사용하므로 로그인페이지 접속시 한번 날려줌
    localStorage.clear();
    document.cookie = 'JSESSIONID=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    const cookies = document.cookie.split('; ');
    for (let c = 0; c < cookies.length; c++) {
      const d = window.location.hostname.split('.');
      while (d.length > 0) {
        const cookieBase = encodeURIComponent(cookies[c].split(';')[0].split('=')[0]) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
        const p = window.location.pathname.split('/');
        document.cookie = cookieBase + '/';
        while (p.length > 0) {
          document.cookie = cookieBase + p.join('/');
          p.pop();
        }
        d.shift();
      }
    }
    if (this.props.logout) {
      this.props.logout();
    }
  };

  async login() {
    const {loginId} = this.state;
    //TODO 항상 else만 타게 한 코드..?
    if (this.props.isSSO && this.props.isSSO === false) {
      if (!this.props.mainPath) {
        alert('Layout에 이동할 main 경로를 입력해주세요.');
        return;
      }
      if (this.props.onLogin) {
        this.props.onLogin(loginId);
      }
    } else {
      var crypto = require("crypto");
      var shasum = crypto.createHash("sha256");

      await shasum.update(this.state.loginPassword);
      var output = await shasum.digest("hex");
      this.onLoginSSO(loginId, output);
    }
  }

   async onLoginSSO(id, pw) {
    console.log("로그인버튼 클릭::");
    const userInfo = {
      id: id,
      password: pw,
    };
    try {
      return PortalRepository.instance.onLogin(userInfo)
        .then(result => {
          console.log('PortalRepository.instance.onLogin=>', result);
          if(!(result.data && result.data.nameValues)){
            console.log("result.data:::::", result.data)
            return dialog.alert(message("사용자 권한이 없습니다."));
          }
          if (result && result.status && result.status === 200) {
            result.data.nameValues.forEach(item => {
              localStorage.setItem(item.name, typeof item.value === "object" ? JSON.stringify(item.value) : item.value);
              if (item.name === 'Posco.auth.userInfo') {
                localStorage.setItem('gcsCompCode', item.value.gcsCompCode);
              }
            })

            // if (result.data.nameValues[0].name === 'accessToken') {
            //   localStorage.setItem('access_Token', result.data.nameValues[0].value);
            // }
            // if (result.data.nameValues[1].name === 'refreshToken') {
            //   localStorage.setItem('refresh_Token', result.data.nameValues[1].value);
            // }
            // if (result.data.nameValues[2].name === 'userInfo') {
            //   localStorage.setItem('Posco.auth.userInfo', JSON.stringify(result.data.nameValues[2].value));
            //   localStorage.setItem('gcsCompCode', result.data.nameValues[2].value.gcsCompCode);
            // }
            // if (result.data.nameValues[4].name === 'Posco.auth.userMenu') {
            //   localStorage.setItem('Posco.auth.userMenu', JSON.stringify(result.data.nameValues[4].value));
            // }
            localStorage.setItem('Posco.auth.userId', id);
            window.location.href = '/o10t01-front';
          }
        });
    } catch (err) {
      console.log(err.message);
    }
  }


  /**로그인버튼 클릭**/
  onClickLogin(e) {
    e.preventDefault();
    this.login();
  }

  onClickSignUp(e) {
    e.preventDefault();
    window.location.href = '/o10t01-front/signup';
  }

  onChange(e, data) {
    this.setState({
      loginId: data.value,
    });
    // this.props.onChangeId(data.value);
  }

  onChangePassword(e, data) {
    this.setState({
      loginPassword: data.value,
    });
    //  this.props.onChangePassword(data.value);
  }

  handleKeyPress(event) {
    if (event.key === 'Enter') {
      // console.log('Enter');
      this.login();
    }
  }


  renderHeader() {
    return (
      <div className="login-head">With POSCO</div>
    );
  }

  renderContent() {

    const cssStyle = {
      width: '180px', height: '30px', lineHeight: '30px', marginTop: '20px',
      fontSize: '15px', /*color: '#00bc81',*/color: '#fff', textDecoration: 'none',
    };

    return (
      <div className="login-cont">
        <div className="login-box">
          <div style={{height: '80px'}}>
            <Input placeholder="아이디"
                   icon={{name: 'user circle'}}
                   iconPosition="left"
                   onChange={this.onChange}
                   value={this.state.loginId}
                   onKeyPress={this.handleKeyPress}
                   ref={(input) => {
                     this.nameInput = input;
                   }}
                   autoFocus
            />
          </div>
          <div style={{height: '80px'}}>
            <Input placeholder="비밀번호"
                   type="password"
                   onChange={this.onChangePassword}
                   icon={{name: 'lock'}}
                   iconPosition="left"
                   value={this.state.loginPassword}
                   onKeyPress={this.handleKeyPress}
                   style={{height: 50}}
            />
          </div>
          <Link to="" className="btn-login" onClick={this.onClickLogin}>로그인</Link>
          <Footer/>
        </div>
      </div>
    );
  }

  renderPosco() {
    return (
      <div className="login-wrap">
        <div className="login-area">
          {this.renderHeader(LoginLogoImg)}
          {window.location.href.includes("tinvest") || window.location.href.includes("localhost") || window.location.href.includes("test.steel-n.com") ? this.renderContent() : null}
          <SpinnerViewer/>
        </div>
      </div>
    );
  }

  render() {
    return this.renderPosco();
  }
}

export default Login;
